import React from 'react'

const Title = () => {
    return (
        <div>
  
<link href="https://fonts.googleapis.com/css?family=Archivo+Black&display=swap" rel="stylesheet"/>

<h1 class="playful" aria-label="Wash your hands">
  <span aria-hidden="true">S</span><span aria-hidden="true">H</span><span aria-hidden="true">O</span><span aria-hidden="true">P</span><span aria-hidden="true"> 
  </span>
  <span aria-hidden="true"></span><span aria-hidden="true">N</span><span aria-hidden="true">O</span><span aria-hidden="true">W</span>

</h1>
        </div>
    )
}

export default Title